import * as React from 'react';

import { Close, Icon } from '../../components/Icon';

import styles from './TakeoverModal.module.css';

interface TakeoverModalProps extends React.PropsWithChildren {
  className?: string;
  onClose: () => void;
}

interface TakeoverModalState {}

export class TakeoverModal extends React.Component<
  TakeoverModalProps,
  TakeoverModalState
> {
  handleClickClose = () => {
    this.props.onClose();
  };

  render() {
    return (
      <div className={`${styles.TakeoverModal} ${this.props.className}`}>
        <div className={styles.TakeoverModalHeader}>
          <Icon
            className={styles.Back}
            icon={Close}
            size={2}
            onClick={this.handleClickClose}
          />
        </div>
        <div className={styles.Content}>{this.props.children}</div>
      </div>
    );
  }
}
